<!-- <span class="rooms-text">{{ 'SELECT-QUANTITY-ROOMS' | translate }}</span>
<span class="dropdown-title">{{ currentPrototype }}</span> -->
<!-- <div *ngIf="building"  class="filter-title numberOfRooms-title" [class.disabled-filters]="building.showRoomsSwitcher.length < 3">חדרים:</div> -->
<div *ngIf="building" class="filter-title prototype-icon">
                {{ 'PROTOTYPE' | translate }}:</div>
<ul class="num-of-rooms sub-menu-content" *ngIf="building" >
  <li *ngFor="let proto of building.allPrototypesArray" (click)="wichPrototype(proto, $event)" [class.current]="currentProto === proto">
    {{ proto }} <span *ngIf="proto === ''">{{ 'ALL'| translate }}</span>
  </li>
</ul>
